import { ITagResult } from '../../../httpClient/serverApi/types/IResponse';
import { IAnalyticsConnectionMapping } from '../../../settings/types/ISiteSettingsForSiteAdmin';
import { TagRequest } from '../../../ts/ServerApi/requests/TagRequest';

export type ISetAnalyticsExtConnectionForWorkbookResult = ITagResult;

export class SetAnalyticsExtConnectionForWorkbookRequest extends TagRequest<IAnalyticsConnectionMapping, ISetAnalyticsExtConnectionForWorkbookResult> {
  constructor(params: IAnalyticsConnectionMapping) {
    super('analyticsextensions', 'updateWorkbookWithConnection', params);
  }
}
